export const Entites = ['RIB', 'Facture', 'Virement', 'Administration'] as const
export type Entites = typeof Entites[number]
